module.exports = __webpack_public_path__ + "img/1440.e987b95d.jpg";